var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 13.75V15.5",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95898 18.3335H14.2923V17.5002C14.2923 16.5835 13.5423 15.8335 12.6257 15.8335H7.62565C6.70898 15.8335 5.95898 16.5835 5.95898 17.5002V18.3335V18.3335Z",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 18.3335H15.125",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09102 12.5582C5.34102 11.5498 4.16602 9.6665 4.16602 7.49984V4.99984C4.16602 3.15817 5.65768 1.6665 7.49935 1.6665H12.4993C14.341 1.6665 15.8327 3.15817 15.8327 4.99984V7.49984C15.8327 10.6832 13.291 13.2665 10.1243 13.3332C10.0827 13.3332 9.99935 13.3332 9.99935 13.3332",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55755 9.70833C3.93255 9.50833 3.38255 9.14167 2.94922 8.70833C2.19922 7.875 1.69922 6.875 1.69922 5.70833C1.69922 4.54167 2.61589 3.625 3.78255 3.625H4.32422C4.15755 4.00833 4.07422 4.43333 4.07422 4.875V7.375C4.07422 8.20833 4.24922 8.99167 4.55755 9.70833Z",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4414 9.70833C16.0664 9.50833 16.6164 9.14167 17.0497 8.70833C17.7997 7.875 18.2997 6.875 18.2997 5.70833C18.2997 4.54167 17.3831 3.625 16.2164 3.625H15.6747C15.8414 4.00833 15.9247 4.43333 15.9247 4.875V7.375C15.9247 8.20833 15.7497 8.99167 15.4414 9.70833Z",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.51b01d955034b6a075dbca8388ae9b96.svg";
export { ForwardRef as ReactComponent };